import React from 'react';
import SMOwnerListSummaryView from './SMOwnerListSummaryView';
import SMReputationListView from 'components/reputations/SMReputationListView';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import moment from 'moment';
import SMConst from 'lib/SMConst';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMOwnerHelper from 'components/helpers/SMOwnerHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMRestClient from 'lib/SMRestClient';

class SMOwnerReputationListView extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
    };
  }
  
  componentDidMount() {
  }
  
  render() {
    
    const owner = this.props.owner;
    
    return(
      <div className="site-main">
        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              <SMOwnerListSummaryView owner={owner} />
              <div className="col-sm-12 col-md-8">
                <div className="mod-review">
                  <h2 className="page-subtitle">評価とレビュー</h2>
                  <ul className="mod-review__head">
                    <li className="mod-review__head-star">
                      <a href={Routes.reputations_owner_path(owner.username)}>{SMRenderHelper.renderReviewStars(owner.reputation_score)}</a>
                    </li>
                    <li className="mod-review__head-rating" itemProp="ratingValue">{owner.reputation_score}</li>
                    <li itemProp="reviewCount">
                      <a href={Routes.reputations_owner_path(owner.username)} className="space-head__list-number">{owner.reputation_count}件</a>
                    </li>
                  </ul>
                  <SMReputationListView reputated="Owner" reputations={this.props.reputations} />
                </div>                
                <SMSearchPagerView 
                  delegate={this}
                  perPage={this.props.perPage}
                  totalCount={this.props.totalCount}
                  currentPage={this.props.currentPage}
                  options={{className: "details__main-nav"}}
                  links={SMRestClient.parseLinkString(this.props.linkString)} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
}
export default SMOwnerReputationListView;



// WEBPACK FOOTER //
// ./app/javascript/components/owners/SMOwnerReputationListView.jsx